<template>
  <div class="person-card">
    <img 
      :src="validarImagen(image)"
      @error="setAltImg"
      height="100px"
      width="100%"
      class="person-card__img" 
    >
    <div class="person-card__body">
      <a href="#" class="person-card__body__name">{{ name }}</a>
      <p class="person-card__body__text">{{ texto }}</p>
      <span class="person-card__body__tag">{{ tag }}</span>
    </div>
  </div>
</template>

<script>

  import logoImg from '../../assets/logo.png'
  import notImg from '@/assets/not-image.png'

  export default {
    name: 'VSimplePersonCard',
    props: {
      image: String,
      name: String,
      texto: String,
      tag: String
    },
    methods: {
      setAltImg(event) { 
        event.target.src = notImg
      },
      validarImagen: function (imagen) {
        if (imagen) {
          return imagen
        } else {
          return logoImg
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.person-card {
  margin: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  &__img {
    width: 100%;
    height: 100px;
  }
  &__body {
    border: 1px solid $color-3;
    position: relative;
    top: -20px;
    background: $color-white;
    width: 90%;
    padding: 10px;
    border-radius: 10px;
    &__name {
      font-size: 14px;
      font-family: $ff-3;
      color: $color-1;
      text-decoration: none;
      font-weight: bold;
      display: block;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__text {
      font-size: 12px;
      font-family: $ff-3;
      color: $color-9;
      margin: 0px;
    }
    &__tag {
      position: absolute;
      bottom: 3px;
      right: 3px;
      font-size: 10px;
      font-weight: bold;
      font-family: $ff-1;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 25px;
      height: 25px;
      background: $color-2;
      color: $color-white;
      border-radius: 50%;
    }
  }
}
</style>